<template>
  <div class="win-socket-page">
    <slot></slot>
  </div>
</template>
<script>
import { LongRpc } from '@/utils/internet.js';
import api from "@/api";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
import { getSocketUrl } from '@/utils/websocket'
export default {
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      langMap:langMap,
      // 保存到此处实现复制
      socketCase: null,
      focusFn: null
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
  },
  methods: {
    onFocus() {
      this.$emit('pageFocus');
      this.connectSocket();
    },
    connectSocket(url) {
      let socket = this.socketCase;
      if (!socket) {
        // 初次连接
        socket = new LongRpc(url);
        socket.start();
      } else if (socket.getConnectState() === 'closed') {
        // 已关闭情况重新连接
        socket.start();
      } else return;
      // 添加消息监听
      socket.addEventListener('message', this.onMessage.bind(this));
      socket.addEventListener('open', this.onSuccess);
      this.socketCase = socket;
    },
    // 连接成功
    onSuccess() {
      console.info('[连接成功]');
      this.$emit('open');
    },
    send(data) {

      this.socketCase.send(JSON.stringify(data));
    },
    // 消息监听
    onMessage(data) {
      let _d = JSON.parse(data);
      try {
        if( Object.prototype.toString.call(_d.data) === '[object String]'){
          _d.data = JSON.parse(_d.data);
        }
      } catch (er) {
        console.warn(er);
      }
      this.$emit('message', _d);
    },
    getConfig() {
        this.connectSocket(getSocketUrl()+'/ssdd');
    },
    init() {
      if (this.url) this.connectSocket(this.url);
      else {
        this.getConfig();
      }
      // 监听是否离开页面
      this.focusFn = this.onFocus.bind(this);

      window.addEventListener("focus", this.focusFn);
      window.addEventListener("blur", () => {
        this.$emit('pageBlur');
      });
    }
  },
  mounted() {
    /* 测试使用
    setTimeout(() => {
      this.onMessage(JSON.stringify({
        type: 'online:', robotId: 1, data: { type: '提示', msg: '围栏故障' }
      }));
    },2000);
    let d = {type:'situation',robotId:1,data: "{\"id\":356,\"type\":\"cloud\",\"robotId\":1,\"robotCode\":\"CS2138123\",\"fileName\":\"/cloud/cloud20230518113545247243.png\",\"basePath\":\"http://123.60.189.195/file\",\"data\":\"{\\\"code\\\":200,\\\"message\\\":\\\"成功\\\",\\\"data\\\":\\\"null\\\",\\\"success\\\":\\\"true\\\"}\",\"timestamp\":1684380945,\"createUser\":0,\"createTime\":1684380945247}" }
    var qq = setInterval(() => {
      this.onMessage(JSON.stringify(d));
    }, 5000);
    setTimeout(() => {
      window.clearInterval(qq);
      this.onMessage(JSON.stringify({
        type: 'offline:', robotId: 1, data: { type: '提示', msg: '围栏故障' }
      }));
    }, 90000);*/
  },
  beforeDestory() {
    // 销毁时取消监听
    window.removeEventListener(window, 'focus', this.focusFn);
  }
}
</script>
<style scoped>
.win-socket-page{
  height: 100%;
  background-color: #000c17;
}
</style>
